const PasswordUrls = {
  CHANGE_PASSWORD: `${process.env.REACT_APP_USER_ANA_URL}/ana/update`,
  SECURITY_QUESTION: `${process.env.REACT_APP_USER_ANA_URL}/ana/retrieveQA`,
  RESET_PASSWORD: `${process.env.REACT_APP_USER_ANA_URL}/ana/resetpwd`,
  UPDATE_SECURITY_QUESTION: `${process.env.REACT_APP_USER_ANA_URL}/ana/updateQA`,
  VALIDATE_SECURITY_QUESTION: `${process.env.REACT_APP_USER_ANA_URL}/ana/validateQA`
};

export default PasswordUrls
